import {createContext, Dispatch, FC, useMemo, useReducer} from 'react';
import {
  AlertAction,
  alertReducer,
  AlertState,
} from 'contextApi/reducers/error.reducer';

export type AlertLevel = 'error' | 'info' | 'success' | 'warning';
export type AlertDuration = 'short' | 'long';

export const initialSate: AlertState = {
  config: null,
  showing: false,
};

export type AlertContextType = {
  state: AlertState;
  dispatch: Dispatch<AlertAction>;
};

export const alertContext = createContext<AlertContextType>({
  state: initialSate,
  dispatch: () => {
    return initialSate;
  },
});

const AlertProvider: FC = ({children}) => {
  const [state, dispatch] = useReducer(alertReducer, initialSate);
  const value = useMemo(() => ({state, dispatch}), [state, dispatch]);
  return (
    <alertContext.Provider value={value}>{children}</alertContext.Provider>
  );
};

export default AlertProvider;
